import { StandoutTypeConfig } from './types';
import { EnumStandoutTextBlockType } from '$/(cms)/_modules/cmsService/types';

export const DEFAULT_TYPE = EnumStandoutTextBlockType.Tips;

export const TYPE_CONFIGS: Record<
  EnumStandoutTextBlockType,
  StandoutTypeConfig
> = {
  [EnumStandoutTextBlockType.Tips]: {
    icon: 'emoji_objects',
    headerBgClass: 'bg-fill/primary',
    bodyGradient:
      'linear-gradient(180deg, var(--fill-primary-light) 0%, #FFFFFF 100%)',
    buttonHoverClass: '',
    buttonToneClass: '',
  },
  [EnumStandoutTextBlockType.Takeaways]: {
    icon: 'bookmark',
    headerBgClass: 'bg-fill/primary',
    bodyGradient:
      'linear-gradient(180deg, var(--fill-primary-light) 0%, #FFFFFF 100%)',
    buttonHoverClass: '',
    buttonToneClass: '',
  },
  [EnumStandoutTextBlockType.ExpertPerspective]: {
    icon: 'neurology',
    headerBgClass: 'bg-[--highlights-green-dark]',
    bodyGradient:
      'linear-gradient(180deg, var(--highlights-green-light) 0%, #FFFFFF 100%)',
    buttonHoverClass:
      'hover:!bg-[--highlights-green-dark] hover:!text-text/on-dark hover:!border-[--highlights-green-dark]',
    buttonToneClass:
      '!text-[--highlights-green-dark] !border-[--highlights-green-dark]',
  },
  [EnumStandoutTextBlockType.EditorsPick]: {
    icon: 'stylus_fountain_pen',
    headerBgClass: 'bg-fill/primary',
    bodyGradient:
      'linear-gradient(180deg, var(--fill-primary-light) 0%, #FFFFFF 100%)',
    buttonHoverClass: '',
    buttonToneClass: '',
  },
};
